import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { RoleForm, RoleQueries } from '@portal/app-admin'

export const Route = createFileRoute('/_auth/preferences/roles/$roleId/edit')({
  component: EditRoleRoute,
})

function EditRoleRoute() {
  const { roleId } = Route.useParams()
  const navigate = useNavigate()
  const { data: role } = useSuspenseQuery(RoleQueries.detail(Number(roleId)))

  return (
    <RoleForm
      role={role}
      onClose={() =>
        void navigate({
          to: '/preferences/roles/$roleId',
          params: { roleId },
          search: { tab: 'access' },
        })
      }
    />
  )
}
